import React from "react";
import Accordion from "../Accordion/Accordion";
import Text from "../Text/Text";
import AccordionItem, {
  AccordionContent,
  AccordionHeader,
} from "../Accordion/AccordionItem/AccordionItem";
import DimensionIcon from "../DimensionIcon";
import styles from "./Recommendations.module.scss";
import Icon from "../../assets/icons/Icon";

function Recommendations(props) {
  const { recommendations } = props;
  return (
    <div className={styles.recommendations}>
      <div className={styles.recommendations_wrapper}>
        <Text
          variant="h4"
          weight="medium"
          className={styles.recommendations_title}
        >
          Explore your recommendations below
        </Text>
        <Accordion allowToggle backgroundStyle="ghost">
          {recommendations.map((recommendation, index) => (
            <AccordionItem
              title={
                index > 3
                  ? "To get a full overview of your digital maturity, get in touch with us."
                  : null
              }
              isDisabled={index > 3}
              key={recommendation.dimension}
            >
              <AccordionHeader>
                <div className={styles.recommendations_header}>
                  <DimensionIcon
                    isDisabled={index > 3}
                    dimension={recommendation.dimension}
                  />{" "}
                  {recommendation.dimension}
                </div>
              </AccordionHeader>
              <AccordionContent>
                <RankMovement
                  from={recommendation.result.from}
                  to={recommendation.result.to}
                />
                <Text>{recommendation.result.recommendation}</Text>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}

export default Recommendations;

function RankMovement(props) {
  const { from, to } = props;

  return (
    <Text weight="bold" className={styles.movement}>
      {from}
      <Icon icon="GtArrowRight" />
      {to}
    </Text>
  );
}
